import { defineStore } from 'pinia'
import { ref } from 'vue'

export type LoginTab = 'sms' | 'email' | 'wechat'

export type LoginModalOpenOptions = {
  nextPath?: string
  cancelPath?: string
  defaultInvitationCode?: string
  tab?: LoginTab
}

export const useLoginModalStore = defineStore('loginModal', () => {
  const open = ref(false)
  const nextPath = ref('')
  const cancelPath = ref('')
  const defaultInvitationCode = ref('')
  const tab = ref<LoginTab>('sms')

  function show(opts?: LoginModalOpenOptions) {
    nextPath.value = String(opts?.nextPath || '').trim()
    cancelPath.value = String(opts?.cancelPath || '').trim()
    defaultInvitationCode.value = String(opts?.defaultInvitationCode || '').trim()
    tab.value = (opts?.tab || 'sms') as LoginTab
    open.value = true
  }

  function close() {
    open.value = false
    nextPath.value = ''
    cancelPath.value = ''
    defaultInvitationCode.value = ''
    tab.value = 'sms'
  }

  return { open, nextPath, cancelPath, defaultInvitationCode, tab, show, close }
})
